"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const CommonWeb_1 = require("./CommonWeb");
const TGLabelWrapperWeb_1 = __importDefault(require("./TGLabelWrapperWeb"));
const useDataProvider_1 = require("../../hooks/useDataProvider");
const TGRadioFieldWeb = (props) => {
    const { options, label, dataProvider, error, warning, helperText, required, readOnly, info, translateFunction = text => text } = props, radioGroupProps = __rest(props, ["options", "label", "dataProvider", "error", "warning", "helperText", "required", "readOnly", "info", "translateFunction"]);
    const { loading, options: dataProviderOptions, computeOptions, } = (0, useDataProvider_1.useDataProvider)({
        dataProvider,
        options,
    });
    const [tooltip, setTooltip] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        computeOptions(undefined, true);
    }, [computeOptions]);
    const classes = (0, CommonWeb_1.useStyles)();
    const customStyles = useCustomStyles();
    return (react_1.default.createElement(core_1.FormControl, { component: "fieldset", className: classes.formElementWrapper, error: error, 
        // We want the Tooltip to be triggered on field hovering, but positionned relative to the label
        onMouseEnter: () => readOnly && setTooltip(true), onMouseLeave: () => readOnly && setTooltip(false) },
        react_1.default.createElement(core_1.FormLabel, { component: "legend", className: (0, clsx_1.default)(warning && classes.warningText) },
            react_1.default.createElement(TGLabelWrapperWeb_1.default, { required: required, readOnly: readOnly, label: label, info: info, tooltip: tooltip, error: error, translateFunction: translateFunction })),
        !loading && dataProviderOptions && (react_1.default.createElement(core_1.RadioGroup, Object.assign({}, radioGroupProps, { style: styles.rootContainer }), dataProviderOptions.map((option, index) => (react_1.default.createElement(core_1.FormControlLabel, { key: index, value: option.value, control: react_1.default.createElement(core_1.Radio, { className: classes.radioButton }), label: option.label, disabled: readOnly, style: styles.radioRoot, className: customStyles.dropdown }))))),
        helperText && (react_1.default.createElement(core_1.FormHelperText, { className: (0, clsx_1.default)(warning && classes.warningText) }, translateFunction(helperText)))));
};
const useCustomStyles = (0, core_1.makeStyles)((theme) => (0, core_1.createStyles)({
    dropdown: {
        '& .MuiTypography-body1': {
            fontSize: 15,
            fontWeight: 400,
        },
    },
}));
const styles = {
    radioRoot: {
        height: 22,
    },
    rootContainer: {
        gap: 10,
    },
};
exports.default = TGRadioFieldWeb;
//# sourceMappingURL=TGRadioFieldWeb.js.map